import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";

const ConsentModal = ({ show, setShowConsentModal, addIp, ipAddress }) => {
  const labels = useSelector((state) => state.labels.data);
  const navigate = useNavigate();

  const handleClose = () => {
    setShowConsentModal(false);
  };

  const addIpFunction = () => {
    let reqBody = {
      cidr: ipAddress + "/32",
      type: "Login",
    };
    addIp(reqBody);
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        {/* <Modal.Title>
          {labels?.account?.["ip-whitelisting"]?.headingIPAddress ||
            "Confirm IP Whitelist"}
        </Modal.Title> */}
      </Modal.Header>

      <Modal.Body>
        <div className="row" style={{ paddingBottom: "15px" }}>
          <div className="col-md-12">
            <p>
              {labels?.account?.["ip-whitelisting"]?.warningMessage ||
                "Are you sure you want to add this IP to the whitelist?"}
            </p>
          </div>
        </div>

        <div className="row" style={{ paddingBottom: "15px" }}>
          <div className="col-md-12">
            <p>
              {labels?.account?.["ip-whitelisting"]?.warningMessageOptions ||
                "You will be logged out after this operation."}
            </p>
          </div>
        </div>

        <div className="row" style={{ paddingBottom: "15px" }}>
          <div className="col-md-6">
            <div className="form-group">
              <button
                className="btn button-danger"
                type="button"
                style={{ width: "100%" }}
                onClick={addIpFunction}
              >
                {labels?.account?.["ip-whitelisting"]?.yes || "Yes"}
              </button>
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <button
                className="btn button-danger"
                type="button"
                style={{ width: "100%" }}
                onClick={handleClose}
              >
                {labels?.account?.["ip-whitelisting"]?.no || "No"}
              </button>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ConsentModal;
